import { OpenResourceCardTask } from '@/Core/Tasks/Resources/OpenResourceCardTask'

import { APPLICATION_DRAWER_WIDTH, APPLICATION_RESOURCE } from '../Contracts/IApplication'

/**
 * Поля, які «Копіювати» переносить у нову заявку (`SPEC-021` §5.8; легасі
 * `ApplicationCopyTask.js:7-23`) — 15, як є. Менеджер — поточний, валюти —
 * UAH: їх ставить форма створення (`ApplyApplicationCreateDefaultsTask`).
 */
export const APPLICATION_COPY_FIELDS = [
    'client',
    'loadingCountries',
    'loadingAddresses',
    'unloadingCountries',
    'unloadingAddresses',
    'cargo',
    'typesCars',
    'description',
    'forwarder1',
    'placeCountryDeparture',
    'personResponsibleLoading',
    'placeDestination',
    'personResponsibleUnloading',
    'costCargoInvoice',
    'quantityWeightCargo',
] as const

/**
 * Відкрити форму створення з полями заявки-джерела. Після закриття форми —
 * `onDone` (перечитати список, легасі `:36-38`).
 */
export const CopyApplicationTask = (values: Record<string, unknown>, onDone?: () => void): void => {
    const initialValues: Record<string, unknown> = {}

    for (const field of APPLICATION_COPY_FIELDS) {
        const value = values[field]

        if (value !== undefined && value !== null) initialValues[field] = value
    }

    OpenResourceCardTask({
        resource: APPLICATION_RESOURCE,
        mode: 'create',
        displayMode: 'drawer',
        drawer: { width: APPLICATION_DRAWER_WIDTH },
        initialValues,
        ...(onDone ? { onClose: onDone } : {}),
    })
}
